import startOfWeek from 'date-fns/startOfWeek'
import { restClient } from '../config/restClient'

export const fetchNotifications = async member_profile_id => {
  const result = await restClient(`/api/member_profiles/${member_profile_id}/notifications`, {
    method: 'GET',
    params: {
      start_time: startOfWeek(new Date(), { weekStartsOn: 1 }),
      order_by: 'created_at',
      order_direction: 'desc',
    },
  })

  return result.data.result
}

export const updateNotifications = async (member_profile_id, data) => {
  const result = await restClient(`/api/member_profiles/${member_profile_id}/notifications/${data.id}`, {
    method: 'PATCH',
    data,
  })

  return result.data.result
}
